import type { IconDefinition } from './types'

import conCreateDataset from './baseIcons/conc/conCreateDataset'
import conDatabase from './baseIcons/conc/conDatabase'
import conDatabasePlus from './baseIcons/conc/conDatabasePlus'
import conDataset from './baseIcons/conc/conDataset'
import conFolderPlus from './baseIcons/conc/conFolderPlus'
import conInsightSearchAlt from './baseIcons/conc/conInsightSearchAlt'
import conLNGBunkering from './baseIcons/conc/conLNGBunkering'
import conMachineLearning from './baseIcons/conc/conMachineLearning'
import conReport from './baseIcons/conc/conReport'
import conReport1 from './baseIcons/conc/conReport1'
import conSensorAlt from './baseIcons/conc/conSensorAlt'
import conSensorPlus from './baseIcons/conc/conSensorPlus'
import conUploadFile from './baseIcons/conc/conUploadFile'
import falCheck from './baseIcons/ui/uiCheck'
import cuiCheckboxIndeterminate from './baseIcons/ui/uiCheckboxIndeterminate'
import cuiCheckboxSelected from './baseIcons/ui/uiCheckboxSelected'
import cuiCheckboxUnselected from './baseIcons/ui/uiCheckboxUnselected'
import falCheckCircle from './baseIcons/ui/uiCheckCircle'
import falEllipsisH from './baseIcons/ui/uiEllipsisH'
import falEllipsisV from './baseIcons/ui/uiEllipsisV'
import falExclamationCircle from './baseIcons/ui/uiExclamationCircle'
import falExclamationTriangle from './baseIcons/ui/uiExclamationTriangle'
import culEyeAssess from './baseIcons/ui/uiEyeAssess'
import falInfoCircle from './baseIcons/ui/uiInfoCircle'
import falPlus from './baseIcons/ui/uiPlus'
import cuiRadioSelected from './baseIcons/ui/uiRadioSelected'
import cuiRadioUnselected from './baseIcons/ui/uiRadioUnselected'
import falSpinner from './baseIcons/ui/uiSpinner'
import fadSpinnerThird from './baseIcons/ui/uiSpinnerThird'
import falTimes from './baseIcons/ui/uiTimes'
import falTimesCircle from './baseIcons/ui/uiTimesCircle'

/**
 * Default icons are fundamental to functioning of certain components.
 * They are added to the icon library in order to avoid loading them from CDN.
 */
export const defaultIcons: Record<string, IconDefinition> = {
  conCreateDataset,
  conDatabase,
  conDatabasePlus,
  conDataset,
  conFolderPlus,
  conLNGBunkering,
  conReport,
  conReport1,
  conSensorAlt,
  conSensorPlus,
  conUploadFile,
  conInsightSearchAlt,
  conMachineLearning,
  cuiCheckboxIndeterminate,
  cuiCheckboxSelected,
  cuiCheckboxUnselected,
  cuiRadioSelected,
  cuiRadioUnselected,
  culEyeAssess,
  fadSpinnerThird,
  falCheck,
  falCheckCircle,
  falEllipsisH,
  falEllipsisV,
  falExclamationCircle,
  falExclamationTriangle,
  falInfoCircle,
  falPlus,
  falSpinner,
  falTimes,
  falTimesCircle,
}
